import "./HeroImg2Styles.css";


import React from 'react';
// import IntroImg from "../assets/3.png"

const HeroImg2 = () => {
  return (
    <div className="hero-img">
      <div className="heading">
        <h1>Education and Skills</h1>
        <p>Education is the most powerful weapon which you can use to change the world</p>
      </div>
    </div>
  );
};

export default HeroImg2